window.tinymce.PluginManager.add('assetsembed', function (editor) {
  let onClick = function (assetType) {
    let openRecordList = editor.getParam('open_record_list');

    openRecordList(assetType);

    let fullscreenPlugin = editor.plugins.fullscreen;
    if (fullscreenPlugin && fullscreenPlugin.isFullscreen()) {
      editor.execCommand('mceFullScreen');
    }
  };

  editor.ui.registry.addButton('assetImage', {
    icon: 'image',
    tooltip: 'Insert Image',
    onAction: onClick.bind(this, 'image'),
  });

  editor.ui.registry.addButton('assetVideo', {
    icon: 'embed',
    tooltip: 'Insert Video',
    onAction: onClick.bind(this, 'video'),
  });

  editor.on('click', function () {
    let selectedNode = editor.selection.getNode();

    if (['PICEMBED', 'VIDEOEMBED'].includes(selectedNode.nodeName)) {
      let id = selectedNode.getAttribute('data-asset-id');

      editor.getParam('open_record')(id);
    }
  });
});
